import Model from './Model';

export default class Controller {
	private model: Model = new Model();
	// elementy
	private prirustekEl = <HTMLInputElement>document.getElementById('prirustek');
	private stranaEl = <HTMLInputElement>document.getElementById('strana');
	private posunEl = <HTMLInputElement>document.getElementById('posun');
	private pravdepodonostZmenyBarvyEl = <HTMLInputElement>document.getElementById('pravdepodobnost-zmeny-barvy');

	constructor() {
		this.controll();
	}

	controll() {
		this.prirustekEl.addEventListener('input', () => {
			this.zmenPrirustek();
		});

		this.stranaEl.addEventListener('input', () => {
			this.model.ctverec.zmenStranu(parseInt(this.stranaEl.value));
		});

		this.posunEl.addEventListener('input', () => {
			this.model.ctverec.zmenZlomekPosunu(parseInt(this.posunEl.value));
		});

		this.pravdepodonostZmenyBarvyEl.addEventListener('input', () => {
			this.model.nastavpravdepodobnostZmenyBarvy(parseFloat(this.pravdepodonostZmenyBarvyEl.value));
			console.log(this.pravdepodonostZmenyBarvyEl.value);
		});
	}

	private zmenPrirustek(): void {
		const prirustek = parseInt(this.prirustekEl.value);
		this.model.nastavPocetNovychCtvercu(prirustek);
	}
}
